document.addEventListener('DOMContentLoaded', function() {
  const variantInputs = document.querySelectorAll('.color-variant-input, .morph-variant-input');
  const productImages = document.querySelectorAll('.product__media-item img');

  function formatValue(str) {
    return str.toLowerCase().replace(/'/g, '').replace(/\s+/g, '-');
  }

  function updateImages() {
    let selectedVariant = '';
    let selectedColor = '';

    variantInputs.forEach(input => {
      if (input.checked) {
        if (input.name === 'Raptor' || input.name === 'Morph') {
          selectedVariant = formatValue(input.value);
        } else if (input.name === 'Color') {
          selectedColor = formatValue(input.value);
        }
      }
    });
    
    let selectedValue = selectedColor;
    
    if (selectedVariant !== '') {
      selectedValue = `${selectedVariant}-${selectedColor}`;
    }

    productImages.forEach(image => {
      const imageAlt = image.getAttribute('alt') || '';
      const parentElement = image.closest('.product__media-item');
      if (imageAlt.includes(selectedValue)) {
        parentElement.style.display = 'block';
      } else {
        parentElement.style.display = 'none';
      }
    });
  }

  variantInputs.forEach(input => {
    input.addEventListener('change', updateImages);
  });

  // Initial call to set correct images on page load
  updateImages();
});